import { LitElement, html } from '~/lib/bn-lit-element';
import { openOrderButtonParcel } from '~/parcels/index.js';
import './parcel-loader';

class OpenOrderButton extends LitElement {
  static get properties() {
    return {
      orderHref: { type: String },
      style: { type: Object },
    };
  }

  render() {
    const passThroughProperties = {
      orderHref: this.orderHref,
      style: this.style,
    };

    return html`
      <parcel-loader
        .parcel=${openOrderButtonParcel}
        .passThroughProperties=${passThroughProperties}
      ></parcel-loader>
    `;
  }
}

window.customElements.define('open-order-button', OpenOrderButton);
